import { COMPANY, COMPANY_PAGE } from '../content/copy';
import ContactForm from '../components/ContactForm';

export default function Company() {
  return (
    <>
      <section className="bv-page-hero">
        <div className="bv-wrap">
          <p className="bv-eyebrow">{COMPANY_PAGE.eyebrow}</p>
          <h1 className="bv-h1">{COMPANY_PAGE.title}</h1>
          <p className="bv-product-tag">{COMPANY_PAGE.lead}</p>
          {COMPANY_PAGE.body.map((p) => (
            <p key={p} className="bv-lead">{p}</p>
          ))}
        </div>
      </section>

      <section id="contact" className="bv-section bv-section-surface">
        <div className="bv-wrap bv-split bv-split-start">
          <div>
            <p className="bv-eyebrow">Get in touch</p>
            <h2 className="bv-h2">Work with Black Vanilla</h2>
            <p className="bv-lead">
              Use the form for project conversations. For everything else, email {COMPANY.email}.
            </p>
          </div>
          <ContactForm heading={false} />
        </div>
      </section>
    </>
  );
}
